import { Component, OnInit } from '@angular/core';
import { PickListService } from './pick-list.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-picklist-master',
  imports: [FormsModule, CommonModule, RouterModule],
  standalone: true,
  templateUrl: './picklist-master.component.html',
  styleUrl: './picklist-master.component.scss'
})
export class PicklistMasterComponent implements OnInit {
  picklist: any[] = [];
  currentPage = 1;
  pageSize = 10;
  pageCount = 1;
  loading = false;
  searchQuery: string = '';
  private searchSubject = new Subject<string>();

  constructor(
    private picklistService: PickListService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.fetchPicklist();
    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((term) => {
        this.currentPage = 1;
        this.fetchPicklist();
      });
  }

  fetchPicklist() {
    // Add the search query to the API call
    this.picklistService
      .getPicklists(this.currentPage, this.pageSize, this.searchQuery)
      .subscribe({
        next: (res: any) => {
          this.picklist = res.data;
          this.pageCount = res.pageCount;
        },
        error: (err) => {
          console.error('Failed to fetch picklists:', err);
        },
      });
  }

  // New method to trigger the search
  onSearch() {
    this.searchSubject.next(this.searchQuery);
  }

  pageSizeChange() {
    this.currentPage = 1;
    this.fetchPicklist();
  }

  getVisiblePages(): number[] {
    const pages: number[] = [];
    const start = Math.max(2, this.currentPage - 2);
    const end = Math.min(this.pageCount - 1, this.currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  goToPage(page: number) {
    if (page < 1 || page > this.pageCount || page === this.currentPage) return;
    this.currentPage = page;
    this.fetchPicklist();
  }

  onCreatePicklist(): void {
    // ✅ Navigate to the Create Picklist page
    this.router.navigate(['/picklist/create']);
  }

  downloadPdf(picklistId: any): void {
    // Assuming PicklistService has a method to handle the file stream
    this.picklistService.downloadPickList(picklistId).subscribe({
      next: (response: Blob) => {
        // Logic to trigger browser download
        const fileURL = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `picklist_${picklistId}.pdf`;
        link.click();
        URL.revokeObjectURL(fileURL);
        this.toastr.success('PDF download started.');
      },
      error: (err) => {
        console.error('PDF download failed:', err);
        this.toastr.error('Failed to download the Picklist PDF.');
      },
    });
  }
}
